import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'ai-agents',
});

export const agentDetailRouteRef = createRouteRef({
  id: 'ai-agents-detail',
});

export const providerAccountsRouteRef = createRouteRef({
  id: 'ai-agents-provider-accounts',
});

export const providerAccountDetailRouteRef = createRouteRef({
  id: 'ai-agents-provider-account-detail',
});
